// extracted by mini-css-extract-plugin
module.exports = {"container":"WV","imgContainer":"XV","content":"YV","brand":"ZV","product":"_V","price":"aW","noLink":"bW"};